<div class="footer" [ngClass]="{ footer__secondary: themedFooter }">
  <!-- <span
    ><mat-icon>home</mat-icon>378 Boston Post Road, Unit 214, Orange, CT 06477, USA</span
  >
  <span><mat-icon>mail</mat-icon>info@ravisacademy.com</span>
  <span><mat-icon>local_phone</mat-icon>(959) 300 0660</span> -->
  <span class="footer--first"
    >378 Boston Post Road, Unit 214, Orange, CT 06477, USA</span
  >
  <span>info@ravisacademy.com</span>
  <span class="footer--last">(959) 300 0660</span>
</div>
